import { createCustomEnum } from "./customEnum";

const GofacMatchLevels = createCustomEnum({
	null: {
		name: "null",
		value: 0,
		displayName: "Null",
	},
	exact: {
		name: "exact",
		value: 1,
		displayName: "Exact",
	},
	high: {
		name: "high",
		value: 2,
		displayName: "High",
	},
	conditional: {
		name: "conditional",
		value: 3,
		displayName: "Conditional",
	},
	no_match: {
		name: "no_match",
		value: 4,
		displayName: "Conditional",
	},
	unknown: {
		name: "unknown",
		value: 5,
		displayName: "Unknown",
	},
});

export default GofacMatchLevels;
